import React, { useCallback } from "react";
import "../../index.css";

const Button = React.memo(({ label, onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <button
      className="py-2 px-5 rounded-lg bg-[#7decc6] text-black text-lg font-bold shadow duration-150 hover:text-white hover:bg-[#51a589]"
      onClick={handleClick}
    >
      {label}
    </button>
  );
});

export default Button;
